// extracted by mini-css-extract-plugin
export default {"patient_progress_table":"PatientProgressTable_patient_progress_table__VW2pA"};